import Vue from 'vue';
import API from '@/api';
import _ from 'lodash';
import moment from 'moment';
import * as types from '@/store/mutationTypes';

const state = {
  companyId: null,
  bookedLoads: [],
  loadingLoads: false,
  timestamp: null,
};

const getters = {
  bookedLoads: qbState => qbState.bookedLoads,
  companyId: qbState => qbState.companyId,
  timestamp: qbState => qbState.timestamp,
  loadingLoads: qbState => qbState.loadingLoads,
};

const mutations = {
  [types.START_LOADING](loadState) {
    loadState.loadingLoads = true; // eslint-disable-line no-param-reassign
  },
  [types.SET_BOOKED_LOADS](loadState, { loads, companyId, loading }) {
    loadState.bookedLoads = loads; // eslint-disable-line no-param-reassign
    loadState.companyId = companyId;// eslint-disable-line no-param-reassign
    loadState.loadingLoads = loading; // eslint-disable-line no-param-reassign
    loadState.timestamp = moment(); // eslint-disable-line no-param-reassign
  },
  [types.UPDATE_LOAD_TACTICAL_INFO](loadState, loadData) {
    const load = _.find(loadState.bookedLoads, { humanId: loadData.humanId });
    Vue.set(load, 'tacticalInfo', loadData.tacticalInfo);
  },
  [types.UPDATE_LOAD](loadState, loadData) {
    const loadIndex = _.findIndex(loadState.bookedLoads,
      load => load.humanId === loadData.humanId);
    Vue.set(loadState.bookedLoads, loadIndex, loadData);
  },
  [types.REMOVE_LOAD](loadState, loadId) {
    loadState.bookedLoads = _.reject(loadState.bookedLoads, { humanId: loadId }); // eslint-disable-line no-param-reassign
  },
};

const actions = {
  async getBookedLoads({ commit, dispatch }, companyId) {
    try {
      commit(types.SET_BOOKED_LOADS, { loads: [], companyId, loading: true });
      const response = await API.company.getBookedLoads({ companyId });
      commit(types.SET_BOOKED_LOADS, { loads: response.data.items, companyId, loading: false });
    } catch (error) {
      dispatch('applications/setErrorNotification', {
        message: error.message,
      }, { root: true });
    }
  },
  updateLoadTacticalInfo({ commit }, loadData) {
    commit(types.UPDATE_LOAD_TACTICAL_INFO, loadData);
  },
  updateLoad({ commit }, loadData) {
    commit(types.UPDATE_LOAD, loadData);
  },
  removeLoad({ commit }, loadId) {
    commit(types.REMOVE_LOAD, loadId);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/bookedLoads.js